import { PaymentStatus } from "encamp-prisma/generated/browser";

/**
 * Payment statuses that indicate the payment reached a negative terminal state
 * (i.e. it was cancelled, voided, or failed). This is distinct from PAID, which
 * is also terminal but represents a successful outcome. If Lob reports a check
 * was actually sent while one of these is set, we have a mismatch that needs
 * attention.
 */
export const TERMINAL_FAILURE_PAYMENT_STATUSES: PaymentStatus[] = [
  PaymentStatus.CANCELLED,
  PaymentStatus.VOID,
  PaymentStatus.FAILURE,
];

/**
 * Construct a Lob dashboard URL that filters by the payment's metadata.
 * Uses the metadata search parameter rather than a direct deep link so
 * the environment toggle is set correctly.
 *
 * @param lobMailType - Accepts both Prisma ("CHECK"/"LETTER") and GraphQL ("Check"/"Letter") enum values
 * @param env - The environment name (e.g. "release" for production)
 */
export function getLobDashboardUrl({
  paymentId,
  lobMailType,
  env,
}: {
  paymentId: string;
  lobMailType: string;
  env: string;
}): string {
  const lobType = lobMailType.toUpperCase() === "CHECK" ? "checks" : "letters";
  const mode = env === "release" ? "live" : "test";
  return `https://dashboard.lob.com/${lobType}?metadata=paymentId,${paymentId}&mode=${mode}`;
}
